module.exports = __webpack_public_path__ + "img/default.16f94392.png";